import { gql } from 'graphql-request'

export const GRUPO_FRAGMENT = gql`
  fragment GrupoFragment on Grupo {
    id
    nome
  }
`

export const GRUPOS_QUERY = gql`
  ${GRUPO_FRAGMENT}
  query GruposAtivos {
    gruposAtivos {
      ...GrupoFragment
    }
  }
`
